import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import { Select, SelectMulti } from 'Components/shared/Select'
import { H2 } from 'Components/shared/Typography'
import EncounterItem from 'Components/shared/EncounterItem'
import { alertOptions } from 'Components/shared/SelectAlert'

import { colors } from 'Constants'

import { Flex } from 'lese'

import AutoSizer from 'react-virtualized/dist/es/AutoSizer'
import List from 'react-virtualized/dist/es/List'

import { useStore } from 'laco-react'
import EncountersStore, {
  setSelection,
  setSortingParams,
  setFilteringParams,
  clearFilteringParams,
  loadNextEncounters
} from 'Store/encounters'
import UserStore from 'Store/user'
import Search from './Search/Search'

const SelectContainer = styled(Flex)`
  background: ${colors.background800};
  grid-column: 1;
  padding: 16px;
`

export default () => {
  const { encounters, selectedHl7Id, loaded } = useStore(EncountersStore)
  const [alert, setAlert] = useState([])
  const [formattedAlertOptions, setFormattedAlertOptions] = useState([])
  const [sort, setSort] = useState(0)
  const { user } = UserStore.get()
  const { filteringParams } = EncountersStore.get()

  useEffect(async () => {
    // format the alert options with the correct label
    const options = alertOptions.map(({ ...option }) => {
      const optionLabel = option.value === 0 ? 'Normal' : option.label
      option.label = `${optionLabel} Encounters`
      return option
    })

    setFormattedAlertOptions(options)

    // select all alert options on reset
    if (filteringParams.alertLevel === undefined) {
      setAlert(alertOptions.map(e => e.value))
    }
  }, [filteringParams])

  return (
    <>
      <Search isClusterUser={user ? user.isClusterUser : false} fullWidth />
      <Flex column style={{ gridColumn: '1' }} yAlign="stretch">
        <SelectContainer xAlign="space-between" yAlign>
          <SelectMulti
            title="Filter by Alerts"
            width="220px"
            onChange={({ newValue }) => {
              if (newValue.length === formattedAlertOptions.length) {
                clearFilteringParams()
              } else {
                setFilteringParams({ type: 'ALERTLEVEL', alertLevel: newValue })
              }
              setAlert(newValue)
            }}
            selected={alert}
            options={formattedAlertOptions}
            close
          />
          <Select
            width="200px"
            xAlign="flex-end"
            onChange={({ newValue }) => {
              setSortingParams({ type: newValue })
              setSort(newValue)
            }}
            selected={sort}
            options={['Most Recent', 'Highest Alert Level', 'By Journey']}
            header="Sort by"
          />
        </SelectContainer>
        {/* Fixed the scrollbar issue due to AutoSizer using height: 100% */}
        <Flex style={{ flex: 1 }}>
          <AutoSizer>
            {({ width, height }) => (
              <List
                rowCount={encounters.length}
                rowHeight={90}
                height={height}
                width={width}
                padding="8px 8px"
                noRowsRenderer={() => (
                  <H2 style={{ padding: '16px', textAlign: 'center' }}>
                    {loaded ? 'No encounters' : 'Loading...'}
                  </H2>
                )}
                onScroll={({ clientHeight, scrollHeight, scrollTop }) => {
                  if (scrollHeight < clientHeight + scrollTop + 1000) loadNextEncounters()
                }}
                overscanRowCount={20}
                rowRenderer={({ index, style }) => (
                  <EncounterItem
                    style={style}
                    key={encounters[index].hl7Id}
                    hl7Id={encounters[index].hl7Id}
                    setSelection={setSelection}
                    isSelected={encounters[index].hl7Id === selectedHl7Id}
                    alertLevel={encounters[index].alertEnum}
                    isNew={encounters[index].review.status === 0}
                    medicalRef={encounters[index].medicalRef}
                    tCode={encounters[index].tCode}
                    date={encounters[index].sentDate}
                    journey={encounters[index].journey.title}
                    status={encounters[index].review.statusEnum}
                    inactiveType={encounters[index].inactive.type}
                    inactiveDays={encounters[index].inactive.days}
                    reviewer={
                      encounters[index].review.user?.initials
                        ? encounters[index].review.user.initials
                        : 'None'
                    }
                    appCode={encounters[index].appCode}
                    bio={encounters[index]?.bio !== '' ? encounters[index].bio : undefined}
                    isClusterUser={user ? user.isClusterUser : false}
                  />
                )}
              />
            )}
          </AutoSizer>
        </Flex>
      </Flex>
    </>
  )
}
